import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import { I18n } from 'src/libs/i18n';

import LocalStorage from 'src/utils/LocalStorage';
import LangSelect from 'src/components/layout/TopNav/LangSelect';
import AppFooter from 'src/components/layout/Footer';
import useLogo from 'src/queries/useLogo';
import { ENV } from 'src/constants/app';

type Props = {
  requireNotAuth?: boolean;
  title?: string;
};

const RestrictLayout: React.FC<Props> = ({
  requireNotAuth = true,
  title = '',
}) => {
  const { data } = useLogo();
  const headerColor = process.env.REACT_APP_HEADER_COLOR;

  return LocalStorage.accessToken && requireNotAuth ? (
    <Navigate to={'/'} replace />
  ) : (
    <Layout className="min-h-100vh" style={{ backgroundColor: headerColor }}>
      <div className="header_restrict">
        <Layout.Header
          className="container-lg header_restrict_container"
          style={{ backgroundColor: headerColor }}
        >
          <span className="header_restrict_site_name">
            <Typography.Link href={ENV.FRONTSITE_URL}>
              {data?.netSbsName}
            </Typography.Link>
          </span>
          <div className="header_restrict_title">
            <span className="login_title">{I18n.t(title)}</span>
          </div>
          <div className="header_restrict_language">
            <LangSelect />
          </div>
        </Layout.Header>
      </div>
      <Outlet />
      <AppFooter backgroundColor={false} />
    </Layout>
  );
};

export default RestrictLayout;
